import React from 'react'
/* eslint-disable */
import { BrowserRouter, Routes, Route, Navigate, Link } from 'react-router-dom';

// import { Routes, Route, BrowserRouter } from 'react-router-dom'
import { Login, SocialMonitor, KeywordManagement, VerbatimManagement, NewAggregation, QuestionManagement, SubQuestionManagement, UserManagement, AdminTool } from '../pages'
import { 
  ROUTE_LOGIN, ROUTE_SOCIAL_MONITOR, ROUTE_VERBATIM_MANAGEMENT, ROUTE_KEYWORD_MANAGEMENT, 
  ROUTE_NEW_AGGREGATION, ROUTE_QUESTION_MANAGEMENT, ROUTE_SUB_QUESTION_MANAGEMENT,
  ROUTE_USER_MANAGEMENT,
  ROUTE_ADMIN_TOOL
} from '../constants'

const BackOfficeRouter = () => {
  return (
    <Routes>
      <Route path='/' element={<Login />} />
      <Route path={ROUTE_LOGIN} element={<Login />} />
      <Route path={ROUTE_SOCIAL_MONITOR} element={<SocialMonitor />} />
      {/* <Route path='/social-monitor/:id' element={<SocialMonitorEdit />} /> */}
      <Route path={ROUTE_VERBATIM_MANAGEMENT} element={<VerbatimManagement />} />
      <Route path={ROUTE_KEYWORD_MANAGEMENT} element={<KeywordManagement />} />
      <Route path={ROUTE_NEW_AGGREGATION} element={<NewAggregation />} />
      <Route path={ROUTE_QUESTION_MANAGEMENT} element={<QuestionManagement />} />
      <Route path={ROUTE_SUB_QUESTION_MANAGEMENT} element={<SubQuestionManagement />} />
      {/* <Route path={`${ROUTE_QUESTION_MANAGEMENT}/:type`} element={<QuestionManagement />} /> */}
      {/* <Route path={`${ROUTE_QUESTION_MANAGEMENT}/*`} element={<QuestionManagement />} /> */}
      
      {/* <Route path={ROUTE_QUESTION_MANAGEMENT} element={<QuestionManagement />}>
        <Route path=':type' element={<QuestionManagement />} />
        <Route path='*' element={<QuestionManagement />} />
      </Route> */}
      {/* 
      <Route path="home" element={<Home />} />
        <Route path="user" element={<User />}>
          <Route index element={<Profile />} />
          <Route path="profile" element={<Profile />} />
          <Route path="transactions" element={<Transactions transactions={transactions} />}>
            <Route path=':transactionId' element={<Transaction />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Route> */}

      <Route path={ROUTE_USER_MANAGEMENT} element={<UserManagement />} />
      <Route path={ROUTE_ADMIN_TOOL} element={<AdminTool />} />
      
      <Route path='*' element={<Login />} />

      {/* <Route path={ROUTE_SOCIAL_MONITOR} element={<SocialMonitor />} /> */}
      {/* <ProtectedRoute path={ROUTE_SOCIAL_MONITOR} element={<SocialMonitor />} /> */}
      {/* <Route exact path='/' component={Login} /> */}
      {/* <Route path='*' element={<Navigate replace to='/404' />} /> */}
    </Routes>
  )
}

export default BackOfficeRouter
